import {
  Place,
  TrailerType,
  BrokerId,
  Requirement,
  SortingField,
  SortingOrder,
  SEARCHABLE_REQUIREMENTS,
  USStates,
  PrefixedPlaceId,
  Sorting,
} from '@trucksmarter/shared';
import { DateRange } from '~/app/_ui/Dallas/Forms/DallasDatePicker/date-range';

export const MIN_PRICE_AMOUNT = 0;
export const MAX_PRICE_AMOUNT = 10_000;
export const STEP_PRICE_AMOUNT = 10;

export const MIN_RATE_PER_MILE_AMOUNT = 0;
export const MAX_RATE_PER_MILE_AMOUNT = 20;
export const STEP_RATE_PER_MILE_AMOUNT = 0.1;

export const MIN_WEIGHT_POUNDS = 0;
export const MAX_WEIGHT_POUNDS = 45_000;
export const STEP_WEIGHT_POUNDS = 100;

export const MIN_DISTANCE_MILES = 0;
export const MAX_DISTANCE_MILES = 4_000;
export const STEP_DISTANCE_MILES = 25;

export const MIN_EQUIPMENT_LENGTH_FEET = 0;
export const MAX_EQUIPMENT_LENGTH_FEET = 65;
export const STEP_EQUIPMENT_LENGTH_FEET = 1;

export const DEFAULT_PICKUP_TIME_RANGE_NUM_DAYS = 5;
export const MAX_PICKUP_TIME_RANGE_NUM_DAYS = 14;
export const DEFAULT_RADIUS_MILES = 150;
export const DEFAULT_SORT_FIELD: SortingField = 'recommended';
export const DEFAULT_SORT_ORDER: SortingOrder = 'desc';
export const SUPPORTED_SORT_FIELD_OPTIONS: SortingField[] = [
  'recommended',
  'ratePerMile',
  'createdAt',
  'price',
  'distance',
  'distance',
  'deadheadMiles',
];
export const SUPPORTED_SORT_ORDER_OPTIONS: SortingOrder[] = ['asc', 'desc'];
export const DEFAULT_REQUIREMENTS = Object.fromEntries(
  SEARCHABLE_REQUIREMENTS.map(
    (requirement): [Requirement, RequirementIncludeOption] => [
      requirement,
      'optional',
    ],
  ),
);
export const REQUIREMENT_INCLUDE_OPTIONS = Object.freeze([
  'required',
  'optional',
  'exclude',
] as const);

export type RequirementIncludeOption =
  (typeof REQUIREMENT_INCLUDE_OPTIONS)[number];

export interface LoadBoardSearchZone {
  placeId: PrefixedPlaceId;
  type: 'zone';
  state: USStates[];
}

/**
 * Contrary to Place, state is always an abbreviation
 * or abbreviation array depending on the type
 */
export type LoadBoardSearchLocation = Place | LoadBoardSearchZone;

export default interface LoadBoardSearchFormValues {
  pickupLocations: LoadBoardSearchLocation[] | null;
  pickupRadiusMiles: number;
  deliveryLocations: LoadBoardSearchLocation[] | null;
  deliveryRadiusMiles: number;
  dateRange: DateRange;
  sort: Sorting | null;
  trailerTypes: TrailerType[];
  selectedBrokers: Partial<Record<BrokerId, { label: string; value: string }>>;
  price: [number, number];
  ratePerMile: [number, number];
  weight: [number, number];
  distance: [number, number];
  equipmentLength: [number, number];
  requirements: Partial<Record<Requirement, RequirementIncludeOption>>;
  factorable: boolean | null;
  includeMissingPriceLoads: boolean | null;
}
